import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { PdfExporterModule } from '../pdf-exporter/pdf-exporter.module';
import { ChartWrapperComponent } from './chart-wrapper.component';



@NgModule({
  declarations: [ChartWrapperComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    AppMaterialModule,
    ChartsModule,
    PdfExporterModule
  ],
  exports: [ChartWrapperComponent]
})
export class ChartWrapperModule { }
